import { addMounthsToday, getTodayIsoString } from 'commons/utils/date';
import { Scope } from 'domains/Marketing/enums';
import { CouponValuesInterface } from './types';

export const initialValues: CouponValuesInterface = {
  couponCode: '',
  active: true,
  discountType: 'percentage',
  valuePercentage: '0',
  valueAbsolute: '0',
  includeShipping: false,
  onlyCheapestShipping: false,
  maxDiscountAmount: '',
  maxDiscountAmountType: 'unlimited',
  limitedType: 'unlimited',
  clientLimitationType: 'unlimited',
  combinesWithOtherDiscounts: true,
  maxUses: '0',
  maxUsesPerClient: '0',
  dateType: 'unlimited',
  startDate: getTodayIsoString(),
  endTime: '00:00',
  endDate: addMounthsToday(1),
  startTime: '00:00',
  minPrice: '0',
  scopeType: Scope.ALL,
  categories: [],
  products: [],
};
